import { Select } from '@trackman/web-shared-components';
import React from 'react';
import styled, { css } from 'styled-components';
import { darkgrey, divider, grey, inactive, white } from 'styles/Colors';

export const BoxScoreWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  font-family: 'Lato';
  width: 570px;
  z-index: 10;
`;

export const BoxScoreHeader = styled.div`
  width: 100%;
  height: 40px;
  color: ${white};
  background: ${darkgrey};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  svg {
    position: absolute;
    top: 0;
    right: 5px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    path {
      fill: ${white};
    }
    &:not(.open) {
      top: 2px;
      transform: rotate(180deg);
    }
  }
`;

export const HeaderTitle = styled.span`
  width: 100%;
  height: 100%;
  line-height: 40px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Oswald';
  text-transform: uppercase;
`;

export const BoxScoreContent = styled.div`
  background: ${white};
  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 12;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .box-score-table .rt-table {
    max-height: 300px;
    overflow: auto;
    .rt-tr,
    .rt-thead {
      padding-right: 0px;
    }
  }
`;

export const StyledSelect = styled((props) => <Select {...props} />)`
  width: calc(100% - 20px);
  margin-left: 10px;
  top: 10px;
  margin-bottom: 20px;
  .select-search__value {
    background: ${divider};
    border-radius: 4px;
    border-bottom: 3px solid ${grey};
  }
`;

export const Tip = styled.span`
  width: 100%;
  display: inline-block;
  color: ${grey};
  text-align: center;
  font-size: 11px;
  font-weight: 400;
  padding-bottom: 5px;
`;

export const BoxScoreTabContainer = styled.div`
  margin-bottom: 15px;
  background: ${inactive};
  display: inline-block;
  border-radius: 5px;
  width: calc(100% - 20px);
  margin-left: 10px;
  padding: 2px;
`;

export const BoxScoreTabBtn = styled.label<{ active: boolean }>`
  width: 50%;
  text-align: center;
  background: transparent;
  font-weight: 600;
  font-size: 14px;
  line-height: 10px;
  border-radius: 4px;
  padding: 10px;
  margin: 0;
  cursor: pointer;
  ${(props) =>
    props.active &&
    css`
      background: ${white};
      cursor: default;
    `}
`;
